import $ from "jquery";

const prependWrapperImageCategory = () => {
  let target = {
    body: "body.archive",
    cat: ".product-category img",
  };
  let $category = $(target.cat);
  const init = () => {
    $(document).ready(function () {
      if ($(target.body).length && $category.length) exec();
    });
  };
  const exec = () => {
    $category.wrap('<div class="wrapper-image--category"></div>');
  };
  init();
};

try {
  prependWrapperImageCategory();
} catch (error) {
  throw Error(error);
}
